import withQuery from 'with-query';

import { Category } from '../py-generated/datalouder/stock/types';
import { Region } from '../shared/types';
import { apiUrl, apiv2Url } from './config';
import { getOption, getPromise, postPromise, RequestOptions } from './utils';

const listInfluencerRanksOptions = (region: Region): RequestOptions => ({
  url: withQuery(`${apiUrl}/tips/listInfluencerRanks`, { region }),
  ...getOption(),
});

const getTips = (stockCode?: string, expertID?: number): Promise<any> =>
  getPromise(`${apiUrl}/tips/listTips`, { stockCode, expertID });

const searchInfluencer = (
  abortSignal: AbortSignal,
  influencer: string
): Promise<any> =>
  getPromise(
    `${apiUrl}/tips/searchInfluencer`,
    { influencer },
    data => data.candidates,
    abortSignal
  );

const queryPointInTimePriceOptions = (
  ticker: string,
  date: Date,
  category: Category
): RequestOptions => {
  return {
    url: withQuery(`${apiv2Url}/price/point-in-time`, {
      ticker,
      timestamp: Math.round(date.getTime() / 1000),
      category,
    }),
    ...getOption(),
  };
};

const createOrEditTips = (
  region: Region,
  influencer: string,
  stockCode: string,
  direction: string,
  stockPrice: number,
  date: Date,
  channel: string,
  sourceLink: string,
  keyComment: string,
  priceDate: string,
  openPrice: number,
  tipsId?: string,
  needRefresh?: boolean
): Promise<any> =>
  tipsId
    ? postPromise(`${apiUrl}/tips/editTip`, {
        tipsId,
        region,
        influencer: influencer.trim(),
        stockCode,
        direction,
        stockPrice,
        date,
        channel,
        sourceLink,
        keyComment,
        priceDate,
        openPrice,
        needRefresh,
      })
    : postPromise(`${apiUrl}/tips/createTip`, {
        region,
        influencer: influencer.trim(),
        stockCode,
        direction,
        stockPrice,
        date,
        channel,
        sourceLink,
        keyComment,
        priceDate,
        openPrice,
        needRefresh,
      });

const loadInfluencerWinRates = (
  abortSignal: AbortSignal,
  region: Region,
  influencerId: number
): Promise<any> =>
  getPromise(
    `${apiUrl}/tips/loadInfluencerWinRates`,
    { region, influencerId },
    data => data,
    abortSignal
  );

const doubtTip = (tipsId: string): Promise<void> =>
  postPromise(`${apiUrl}/tips/doubtTip`, {
    tipsId,
  });

const verifyTip = (tipsId: string, shouldVerify: boolean): Promise<void> =>
  postPromise(`${apiUrl}/tips/verifyTip`, {
    tipsId,
    shouldVerify,
  });

export default {
  listInfluencerRanksOptions,
  searchInfluencer,
  queryPointInTimePriceOptions,
  loadInfluencerWinRates,
  createOrEditTips,
  doubtTip,
  verifyTip,
  getTips,
};
